<template>
    <div id="tech">
        <section id="whats-included" class="p-4 lg:px-0 py-12">
            <div class="container">
                <h2 class="title">{{ $t('אוהבים טכנולוגיה') }}</h2>
                <p class="text-center rtl">{{ $t('לצוות הפיתוח שלנו ניסיון עשיר במגוון רחב של טכנולוגיות מהבולטות והחדשניות בשוק.') }}</p>
                <div class="row text-left direction-ltr">
                    <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 media py-md-5 py-lg-5 py-xl-5" data-aos="fade-up" data-aos-duration="1200">
                        <div class="logo">
                            <img src="/img/tech/vue.svg" alt="vue.js" class="align-self-start">
                        </div>
                        <div class="col-10">
                            <p class="h5">Web Application</p>
                            <p>React, Vue, Angular, HTML5, CSS3, Bootstrap4, Redux, Flux, Vuex, unidirectional data flow, SPA, mobile first, SEO, PWA, no jQuery.</p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 media py-md-5 py-lg-5 py-xl-5" data-aos="fade-up" data-aos-duration="1200">
                        <div class="logo">
                            <img src="/img/tech/js.svg" alt="js" class="align-self-start">
                        </div>
                        <div>
                            <p class="h5">Modern JavaScript</p>
                            <p>Node.js, ES6, ES7, ES8, Bible, Webpack, NPM, Yarn, all reactive functional programming.</p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 media py-md-5 py-lg-5 py-xl-5" data-aos="fade-up" data-aos-duration="1200">
                        <div class="logo">
                            <img src="/img/tech/laravel.svg" alt="laravel" class="align-self-start">
                        </div>
                        <div>
                            <p class="h5">RestAPI</p>
                            <p>Express(JS), Meteor(JS), Laravel(PHP), Django(Python), Asp.Net(C#), Spring(Java), RestAPI, TensorFlow, GraphQL, web socket, microservices.</p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 media" data-aos="fade-up" data-aos-duration="1200">
                        <div class="logo">
                            <img src="/img/tech/oracle.svg" alt="database" class="align-self-start">
                        </div>
                        <div>
                            <p class="h5">Database</p>
                            <p>Oracle, SQL, MySQL, NoSQL, PostgREST MongoDB, Elasticsearch, Algolia.</p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 media" data-aos="fade-up" data-aos-duration="1200">
                        <div class="logo">
                            <img src="/img/tech/react.svg" alt="react" class="align-self-start">
                        </div>
                        <div>
                            <p class="h5">Native</p>
                            <p>React Native, NativeScript, Flutter, Weex, cross platforms.</p>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 media" data-aos="fade-up" data-aos-duration="1200">
                        <div class="logo">
                            <img src="/img/tech/git.svg" alt="git" class="align-self-start">
                        </div>
                        <div>
                            <p class="h5">Git & CI</p>
                            <p>Git, Github, Gitlab, issues & merge requests oriented, TFS, eslint, CI, unit tests, docker.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'tech',
    }
</script>

<style lang="css" scoped>
    #tech {
        background: linear-gradient(144deg, #28313B 10%, #485461 65%);
        color: #fff;
    }
    #tech .title {
        text-align: center;
        font-size: 1.875rem;
        font-weight: 300;
        margin-bottom: 1rem;
        line-height: 1.5;
    }
    #tech .logo {
        margin-top: .5rem;
        margin-right: .75rem;
        width: 6rem;
        text-align: center;
    }
    #tech .logo img {
        width: 60px;
    }
    .direction-ltr {
        direction: ltr !important;
    }
</style>
